import ApexCharts from "apexcharts";

const statsMin = (values) => {
  if (!Array.isArray(values) || values.length === 0) return 0;
  return values.reduce((min, val) => (val < min ? val : min), values[0]);
};

const statsMax = (values) => {
  if (!Array.isArray(values) || values.length === 0) return 0;
  return values.reduce((max, val) => (val > max ? val : max), values[0]);
};

const statsQuantile = (values, q) => {
  if (!Array.isArray(values) || values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  const next = sorted[base + 1];
  return next !== undefined ? sorted[base] + rest * (next - sorted[base]) : sorted[base];
};

const statsMedian = (values) => statsQuantile(values, 0.5);

const main = () => {
    const herdElement = document.getElementById('select-herd');
    const seasonElement = document.getElementById('select-season');

    if (!herdElement || !seasonElement) return;

    let selected_herd = herdElement.innerHTML;
    let selected_season = seasonElement.innerHTML;

    console.log("Hello from dashboard.js => main()", selected_herd, selected_season)
    
    fetch(window.location.origin + '/dashboard/getDashboardData?' + new URLSearchParams({
        selected_herd: selected_herd,
        selected_season: selected_season
    }), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }}).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error('Network response was not ok.');
        }}).then(data => {
            console.log("data", data);
            try {
                // - gold indicator graphs
                apexDashGIGrowth(data.goldIndicators, '#gi-overview-growth-plot')
                apexDashGIOpen(data.goldIndicators, '#gi-overview-open-plot')
                apexDashGILength(data.goldIndicators, '#gi-overview-length-plot')
                apexDashGIDeath(data.goldIndicators, '#gi-overview-death-plot')
                // - herd summary graphs
                apexDashHerdCalvesBornBySeason(data.dashHerdData.calvesBirthDied, '#dash-herd-calves-born-by-season-plot');
                apexAnimalTypePolarPlot(data.dashHerdData.thisSeasonAnimals, "#dash-herd-cycle-animals-radar-plot")
                apexDashBirthWeightBoxPlot(data.dashHerdData.birthWeights, "#dash-herd-birth-weight-box")
                apexDashBirthWeightDistributionPlot(data.dashHerdData.birthWeightsHistogram, "#dash-herd-birth-weight-dist-plot")
                apexDashHerdAgeBoxPlot(data.dashHerdData.animalAges, "#dash-herd-age-box-plot")
                apexAnimalAgeDistribution(data.dashHerdData.animalAgesHistogram, "#dash-herd-age-dist-plot")
                apexWeaningWeightBoxPlot(data.dashHerdData.weaningWeights, "#dash-herd-weaning-wt-box-plot")
                apexDashWeaningWtsDistributionPlot(data.dashHerdData.weaningWeightsHistogram, "#dash-herd-weaning-wt-dist-plot")
                apexWeaningAgeBoxPlot(data.dashHerdData.weaningAges, "#dash-herd-weaning-age-box-plot")
                apexWeaningAgeDistribution(data.dashHerdData.weaningAgesHistogram, "#dash-herd-weaning-age-dist-plot")
                // - finances summary graphs
                apexIncomeCategoryBarPlot(data.dashFinancesData.incomeCategory, "#dash-finances-income-category-bar-plot")
                apexExpenseCategoryBarPlot(data.dashFinancesData.expenseCategory, "#dash-finances-expense-category-bar-plot")
                apexTransactionScatterPlot(data.dashFinancesData.transactionsTimeline, "#dash-finances-transactions-scatter-plot")
                // apexBalanceLinePlot(data.dashFinancesData.balanceTimelineData, "#dash-finances-balance-line-plot")
            } catch (error) {
                console.log("error", error)
            }
        }).catch(error => {
            console.error('There has been a problem with your fetch operation:', error);
        });
      
}

export function initDashboard() {
    main();
}


function apexExpenseCategoryBarPlot(data, divId) {
    console.log("from apexIncomeCategoryRadarPlot", data)
    var options = {
    series: data.length > 0 ? [{
        name: 'Expenses',
        data: data.map(d => d[1])
    }] : [],
    noData: {
        text: 'No Data Available...'
    },
    chart: {
        type: 'bar',
        height: 350
    },
    plotOptions: {
        bar: {
            horizontal: true,
            barHeight: '90%',
            endingShape: 'rounded',
            borderRadius: 5,
            borderRadiusApplication: 'end'
        },
    },
    title: {
        text: 'Expenses by Category',
    },
    distributed: true,
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    xaxis: {
        categories: data.length > 0 ? data.map(d => d[0]) : [],
    },
    yaxis: {
        labels: {
            show: false
        },
    },
    tooltip: {
        x: {
            formatter: function (val) {
                return 'CAD ' + val
            }
        }
    },
    fill: {
        opacity: 1,
        colors: ['#e83f33']
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'start',
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
            // Access the category name from w.config.xaxis.categories
            let category = w.config.xaxis.categories[dataPointIndex];
            return category + " : " + "CAD " + value;
        },
        style: {
            fontSize: '11.5px',
            colors: ['black'],
            fontWeight: 400
        },
    },
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();


  
    return chart;

}




function apexIncomeCategoryBarPlot(data, divId) {
    console.log("from apexIncomeCategoryRadarPlot", data)
    var options = {
    series: data.length > 0 ? [{
        name: 'Incomes',
        data: data.map(d => d[1])
    }] : [],
    noData: {
        text: 'No Data Available...'
    },
    chart: {
        type: 'bar',
        height: 350
    },
    plotOptions: {
        bar: {
            horizontal: true,
            barHeight: '90%',
            endingShape: 'rounded',
            borderRadius: 5,
            borderRadiusApplication: 'end'
        },
    },
    title: {
        text: 'Incomes by Category',
    },
    distributed: true,
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    xaxis: {
        categories: data.length > 0 ? data.map(d => d[0]) : [],
    },
    yaxis: {
        labels: {
            show: false
        },
        reversed: true
    },
    fill: {
        opacity: 1,
        colors: ['#5dbf5a']
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'end',
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
            // Access the category name from w.config.xaxis.categories
            let category = w.config.xaxis.categories[dataPointIndex];
            return category + " : " + "CAD " + value;
        },
        style: {
            fontSize: '11.5px',
            colors: ['black'],
            fontWeight: 400
        },
    },
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();


  
    return chart;

}


function apexBalanceLinePlot(data, divId) {
    console.log("from apexBalanceLinePlot", data)
    let trace = data.map(d => {
        return {
            x: d[0],
            y: d[1]
        }
    })
    // Chart options
    var options = {
    chart: {
        type: 'scatter',
        height: 350,
        id: 'dash-balance-line-plot',
        group: 'dash-transactions-timeline-plots-group',
    },
    series: [{
        name: 'Balance',
        data: trace
    }],
    xaxis: {
        type: 'datetime'
    },
    markers: {
        enabled: true,
        size: 12,
        fillOpacity: 0.75
    },
    noData: {
        text: 'No Data Available...'
    },
    title: {
        text: 'Balance Timeline (CAD)',
    },
    };
      
    // var options = {
    // series: trace,
    // chart: {
    // type: 'area',
    // stacked: false,
    // height: 350,
    // zoom: {
    //     type: 'x',
    //     enabled: true,
    //     autoScaleYaxis: true
    // },
    // toolbar: {
    //     autoSelected: 'zoom'
    // }
    // },
    // dataLabels: {
    // enabled: false
    // },
    // markers: {
    // size: 0,
    // },
    // title: {
    // text: 'Stock Price Movement',
    // align: 'left'
    // },
    // fill: {
    // type: 'gradient',
    // gradient: {
    //     shadeIntensity: 1,
    //     inverseColors: false,
    //     opacityFrom: 0.5,
    //     opacityTo: 0,
    //     stops: [0, 90, 100]
    // },
    // },
    // yaxis: {
    // labels: {
    //     formatter: function (val) {
    //     return (val / 1000000).toFixed(0);
    //     },
    // },
    // title: {
    //     text: 'Price'
    // },
    // },
    // xaxis: {
    // type: 'datetime',
    // categories: data.length > 0 ? data.map(d => d[0]) : [], 
    // },
    // tooltip: {
    // shared: false,
    // y: {
    //     formatter: function (val) {
    //     return (val / 1000000).toFixed(0)
    //     }
    // }
    // }
    // };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();


    
    return chart;


}



function apexTransactionScatterPlot(data, divId) {
    console.log("from apexTransactionScatterPlot", data)
    let traces = (data.incomes.data.length > 0 || data.expenses.data.length > 0) ? Object.keys(data).map((key) => {
        console.log("trace:::", data[key])
        return {
            name: data[key].transaction_type,
            data: data[key].data
        }
    }) : []
    var options = {
    // series: [{
    //     name: 'TEAM 1',
    //     data: [
    //         [1327359600000, 30.95],
    //         [1327446000000, 31.34],
    //         [1327532400000, 31.18],
    //     ]
    // },
    // {
    //     name: 'TEAM 2',
    //     data: [
    //         [1327359600000, 30.95],
    //         [1327446000000, 31.34],
    //         [1327532400000, 31.18],
    //     ]
    // }],
    title: {
        text: 'Transactions Timeline (CAD)',
    },
    series: traces,
    chart: {
        height: 350,
        type: 'scatter',
        id: 'dash-transactions-scatter-plot',
        group: 'dash-transactions-timeline-plots-group',
        zoom: {
            type: 'xy'
        }
    },
    dataLabels: {
    enabled: false
    },
    noData: {
        text: 'No data available...'
    },
    grid: {
    yaxis: {
        lines: {
        show: true
        }
    },
    },
    annotations: {
        yaxis: [
            {y: 0, borderColor: '#999', label: {style: {color: '#fff', background: '#00E396'}}}
        ]
    },
    xaxis: {
    type: 'datetime',
    },
    markers: {
        colors: ['#5dbf5a', '#e83f33'],
        fillOpacity: 0.75,
        size: 12
    },
    legend: {
        position: 'top',
        label: {
            useSeriesColors: true
        },
        markers: {
            fillColors: ['#5dbf5a', '#e83f33']
        }
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();

    
    return chart;

}






const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

function getMinQ1MedianQ3Max(data) {
    if (data.length == 0) {
        return [0, 0, 0, 0, 0];
    }
    return [
        statsMin(data),
        statsQuantile(data, 0.25),
        statsMedian(data),
        statsQuantile(data, 0.75),
        statsMax(data)
    ];
}


function apexAnimalTypePolarPlot(data, divId) {
    
    let traces = [
        data.thisSeasonCalves, 
        data.thisSeasonDams, 
        data.thisSeasonSires, 
        data.thisSeasonSteers
    ]
    let options = {
    // title: {
    //     text: 'Summary of Expenses',
    // },
    series: traces, // [80, 50, 30, 40, 100, 20],
    chart: {
    type: 'polarArea',
    height: 425,
    },
    labels: traces.reduce((a, b) => a + b, 0) > 0 ? ['Calves', 'Dams', 'Sires', 'Steers'] : [],
    stroke: {
    colors: ['#fff']
    },
    yaxis: {
        show: false
    },
    fill: {
    opacity: 1
    },
    noDate: {
        text: 'No Data Available...'
    },
    legend: {
    position: 'top'
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
        
        
      
    return chart;
}

const apexAnimalAgeDistribution = (data, divId) => {
    console.log("from apexAnimalAgeDistribution", data)
    console.log("length", Object.keys(data.data).length)
    let traces = Object.keys(data.data).length > 0 ? Object.keys(data.data).map(type => {
        return {
            name: type,
            data: Object.keys(data.data[type]).map(x => {
                return {
                    x: x,
                    y: [0, data.data[type][x]]
                }
            })
        }
    }) : []
    console.log("traces", traces)
    var options = {
    // series: [
    // {
    //     name: 'New York Temperature',
    //     data: [
    //     {
    //         x: 'Jan',
    //         y: [0, 4]
    //     },
    //     {
    //         x: 'Feb',
    //         y: [0, 6]
    //     },
    //     ]
    // }],
    noData: {
        text: 'No Production Cycles Found...'
    },
    series: traces,
    chart: {
    height: 375,
    type: 'rangeArea'
    },
    stroke: {
    curve: 'stepline'
    },
    title: {
    text: 'Herd Age Distribution by Animal Type',
    },
    xaxis: {
        tooltip: {
            enabled: false
        }
    },
    markers: {
        hover: {
            sizeOffset: 5,
    }
    },
    legend: {
        showForSingleSeries: true,
        position: 'top',
    },
    dataLabels: {
        enabled: false
    },
    tooltip: {
        enabled: true,
        y: {
            formatter: function (val, opts) {
                return val == 0 ? "" : val 
                // return val
            }
        },
        x: {
            formatter: function (val) {
                return `Between ${val} and ${parseInt(val) + data.binSize} days`
            }
        }
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
    
    return chart;

}


const apexWeaningAgeDistribution = (data, divId) => {
    console.log("from apexDashBirthWeightDistributionPlot", data)
    console.log("length", Object.keys(data.data).length)
    let traces = Object.keys(data.data).length > 0 ? Object.keys(data.data).map(season => {
        return {
            name: "Production Cycle " + season,
            data: Object.keys(data.data[season]).map(x => {
                return {
                    x: x,
                    y: [0, data.data[season][x]]
                }
            })
        }
    }) : []
    console.log("traces", traces)
    var options = {
    // series: [
    // {
    //     name: 'New York Temperature',
    //     data: [
    //     {
    //         x: 'Jan',
    //         y: [0, 4]
    //     },
    //     {
    //         x: 'Feb',
    //         y: [0, 6]
    //     },
    //     ]
    // }],
    noData: {
        text: 'No Production Cycles Found...'
    },
    series: traces,
    chart: {
    height: 350,
    type: 'rangeArea'
    },
    stroke: {
    curve: 'stepline'
    },
    title: {
    text: 'Weaning Age Distribution by Production Cycle',
    },
    markers: {
        hover: {
            sizeOffset: 5,
    }
    },
    legend: {
        showForSingleSeries: true,
        position: 'top',
    },
    dataLabels: {
        enabled: false
    },
    xaxis: {
        tooltip: {
            enabled: false
        }
    },
    tooltip: {
        enabled: true,
        y: {
            formatter: function (val, opts) {
                return val == 0 ? "" : val 
                // return val
            }
        },
        x: {
            formatter: function (val) {
                return `Between ${val} and ${parseInt(val) + data.binSize} days`
            }
        }
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
    
    return chart;
 
}



const apexDashWeaningWtsDistributionPlot = (data, divId) => {
    console.log("from apexDashBirthWeightDistributionPlot", data)
    console.log("length", Object.keys(data.data).length)
    let traces = Object.keys(data.data).length > 0 ? Object.keys(data.data).map(season => {
        return {
            name: "Production Cycle " + season,
            data: Object.keys(data.data[season]).map(x => {
                return {
                    x: x,
                    y: [0, data.data[season][x]]
                }
            })
        }
    }) : []
    console.log("traces", traces)
    var options = {
    // series: [
    // {
    //     name: 'New York Temperature',
    //     data: [
    //     {
    //         x: 'Jan',
    //         y: [0, 4]
    //     },
    //     {
    //         x: 'Feb',
    //         y: [0, 6]
    //     },
    //     ]
    // }],
    noData: {
        text: 'No Production Cycles Found...'
    },
    series: traces,
    chart: {
    height: 350,
    type: 'rangeArea'
    },
    stroke: {
    curve: 'stepline'
    },
    title: {
    text: 'Weaning Weight Distribution by Production Cycle',
    },
    markers: {
        hover: {
            sizeOffset: 5,
    }
    },
    legend: {
        showForSingleSeries: true,
        position: 'top',
    },
    dataLabels: {
        enabled: false
    },
    xaxis: {
        tooltip: {
            enabled: false
        }
    },
    tooltip: {
        enabled: true,
        y: {
            formatter: function (val, opts) {
                return val == 0 ? "" : val 
                // return val
            }
        },
        x: {
            formatter: function (val) {
                return `Between ${val} and ${parseInt(val) + data.binSize} lbs`
            }
        }
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
    
    return chart;
 
}

const apexDashBirthWeightDistributionPlot = (data, divId) => {
    console.log("from apexDashBirthWeightDistributionPlot", data)
    console.log("length", Object.keys(data.data).length)
    let traces = Object.keys(data.data).length > 0 ? Object.keys(data.data).map(season => {
        return {
            name: "Production Cycle " + season,
            data: Object.keys(data.data[season]).map(x => {
                return {
                    x: x,
                    y: [0, data.data[season][x]]
                }
            })
        }
    }) : []
    console.log("traces", traces)
    var options = {
    // series: [
    // {
    //     name: 'New York Temperature',
    //     data: [
    //     {
    //         x: 'Jan',
    //         y: [0, 4]
    //     },
    //     {
    //         x: 'Feb',
    //         y: [0, 6]
    //     },
    //     ]
    // }],
    noData: {
        text: 'No Production Cycles Found...'
    },
    xaxis: {
        tooltip: {
            enabled: false
        }
    },
    series: traces,
    chart: {
    height: 350,
    type: 'rangeArea'
    },
    stroke: {
    curve: 'stepline'
    },
    title: {
    text: 'Birth Weight Distribution by Production Cycle',
    },
    markers: {
        hover: {
            sizeOffset: 5,
    }
    },
    legend: {
        showForSingleSeries: true,
        position: 'top',
    },
    dataLabels: {
        enabled: false
    },
    tooltip: {
        enabled: true,
        y: {
            formatter: function (val, opts) {
                return val == 0 ? "" : val 
                // return val
            }
        },
        x: {
            formatter: function (val) {
                return `Between ${val} and ${parseInt(val) + data.binSize} lbs`
            }
        }
    }
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
    
    return chart;
 
}

const apexDashBirthWeightBoxPlot = (data, divId) => {
    console.log("from apexDashBirthWeightBoxPlot", data)
    let boxData = Object.keys(data).sort().map(year => {
        return {
            year: year,
            plotData: getMinQ1MedianQ3Max(data[year]),
        }
    })
    console.log("boxData", boxData)
    let traces = boxData.length > 0 ? boxData : []
    let options = {
        series: [{
            data: boxData.map(d => {
                return {
                    x: d.year,
                    y: d.plotData
                }
            })
        }],
        chart: {
            type: 'boxPlot',
            height: 375
        },
        colors: ['#008FFB', '#FEB019'],
        title: {
            text: 'Box Plot of Birth Weights by Production Cycle',
            align: 'left'
        
        },
        noData: {
            text: 'No Production Cycles Found...'
        },
        tooltip: {
            shared: false,
            intersect: true
        }
    };

    let chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
  

}


const apexDashHerdCalvesBornBySeason = (data, divId) => {
    console.log("from apexDashHerdCalvesByYear", data)
    let dataTemp = {
        "Calves Born": data.calvesBornNotDied,
        "Calves Died Before Wean": data.calvesDiedBeforeWean,
        "Missing Birth Dates": data.missingBirthDates
    }
    let traces = data.seasons.length > 0 ? Object.keys(dataTemp).map(key => {
        return {
            name: key,
            data: dataTemp[key]
        }
    }) : [];
    console.log("traces", traces)
    var options = {
    //     series: [{
    //     name: 'PRODUCT A',
    //     data: [44, 55, 41, 67, 22, 43]
    // }, {
    //     name: 'PRODUCT B',
    //     data: [13, 23, 20, 8, 13, 27]
    // }],
    series: traces,
    chart: {
        type: 'bar',
        height: 425,
        stacked: true,
        toolbar: {
        show: true
        },
    },
    noData: {
        text: 'No Production Cycles Found...'
    },
    plotOptions: {
        bar: {
        horizontal: false,
        borderRadius: 10,
        dataLabels: {
            total: {
            enabled: true,
            style: {
                fontSize: '13px',
                fontWeight: 900
            }
            }
        }
        },
    },
    xaxis: {
        categories: data.seasons
    },
    legend: {
        position: 'top',
    },
    title: {
        text: 'Calves Born (and Died) By Production Cycle',
    },
    fill: {
        opacity: [1, 1, 0.4],
    },
    };

    var chart = new ApexCharts(document.querySelector(divId), options);
    chart.render();
}

const apexDashHerdStaggered = (data, divID) => {
    // data should be {"Active": {"Calves": 11, "Dams": ...}, "Dead": {"Calves": 1, "Dams": ...}, ...}
    // create a grouped bar chart for each of the statuses (Active, Dead, Sold, etc.)
    // each bar chart will have a bar for each of the animal types (Calves, Dams, etc.)
    let statuses = Object.keys(data);
    let animalTypes = Object.keys(data[statuses[0]]);
    let traces = [];
    for (let i = 0; i < statuses.length; i++) {
        let trace = {
            "data": [],
            "name": statuses[i],
        }
        for (let j = 0; j < animalTypes.length; j++) {
            trace["data"].push(data[statuses[i]][animalTypes[j]]);
        }
        traces.push(trace);
    }

    let options = {
        series: traces,
        chart: {
            type: 'bar',
            fontFamily: 'Maven Pro, sans-serif',
            height: '100%',
            // dropShadow: {
            //     enabled: true,
            //     color: '#000',
            //     top: 18,
            //     left: 7,
            //     blur: 10,
            //     opacity: 0.2
            // },
        },
        plotOptions: {
            bar: {
                borderWidth: 0,
                borderRadius: 5,
                borderRadiusApplication: 'end',
                borderColor: 'rgba(255,255,255,0.0)',
                backgroundBarColors: ['#fff'],
                backgroundBarOpacity: 1,
                backgroundBarRadius: 15,
                horizontal: false,
                columnWidth: '95%',
                dataLabels: {
                    position: 'bottom',
                    maxItems: 100,
                    hideOverflowingLabels: false,
                    orientation: "horizontal",
                    total: {
                      enabled: true,
                      formatter: undefined,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        color: '#373d3f',
                        fontSize: '14px',
                        fontFamily: undefined,
                        fontWeight: 600
                      }
                    }
                }
            }
        },
        grid: {
            borderColor: '#e7e7e7',
            row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
            },
            show: true,
            // strokeDashArray: 0,
            position: 'back',
            xaxis: {
                lines: {
                    show: true
                }
            },   
            yaxis: {
                lines: {
                    show: true
                }
            },  
            padding: {
                top: 10,
                right: 30,
                bottom: 0,
                left: 10
            },  
        },
        dataLabels: {
            enabled: true,
            // offsetX: -6,
            style: {
                fontSize: '12px',
                colors: ['black']
            },
            dropShadow: {
                enabled: true,
                top: 0.5
            }
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 1,
            colors: ['#fff']
        },
        tooltip: {
            shared: true,
            intersect: false,
            fillSeriesColor: true,
            followCursor: true,
        },
        xaxis: {
            categories: animalTypes,
        },
        legend: {
            position: 'top',
            // horizontalAlign: 'right',
            floating: true,
            // offsetY: -25,
            // offsetX: -20
        },
        title: {
            text: 'Herd By Status',
            align: 'left'
        },
        theme: {
            palette: 'palette1'
        }
    };

    let chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();

}

const apexDashGIGrowth = (data, divID) => {
    // data should be @gold_indicators from controller
    let traces = [{
        name: 'Growth Percentage',
        data: [
            parseFloat(data.mainValues.growth).toFixed(2), 
            parseFloat(data.metaValues.targets.growth).toFixed(2), 
            parseFloat(data.metaValues.regionalBenchmarks.growth).toFixed(2)
        ],
    }]
    let options = {
            series: traces,
            chart: {
                type: 'bar',
                height: 300,
                fontFamily: 'Maven Pro, sans-serif',
                // dropShadow: {
                //     enabled: true,
                //     color: '#000',
                //     blur: 5,
                //     top: 5,
                //     right: 10,
                //     opacity: 0.2
                // },
                // distributed: true,
            },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'start',
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    // Access the category name from w.config.xaxis.categories
                    let category = w.config.xaxis.categories[dataPointIndex];
                    return category + ": " + value + "%";
                },
                style: {
                    fontSize: '18px',
                    colors: ['black'],
                    fontWeight: 400
                },
                dropShadow: {
                    enabled: true,
                    top: 0.5
                }
            },
            xaxis: {
                categories: ["Your Ranch", "Target", "Regional Benchmark"],
            },
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
                xaxis: {
                    lines: {
                        show: true
                    }
                },   
                yaxis: {
                    lines: {
                        show: true
                    }
                },  
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },  
            },
            yaxis: {
                reversed: false,
                fontSize: '24px',
                axisTicks: {
                    show: true
                },
                lines: {
                    show: true
                },
                labels: {
                    show: false,
                    // maxWidth: 160,
                    style: {
                        colors: ['red', 'gray', 'gray'],
                        fontFamily: 'Maven Pro, sans-serif',
                        fontSize: '14px',
                        maxWidth: 50,
                        // fontWeight: 900,
                    }
                }
            },
            theme: {
                palette: 'palette1'
            }
        };

    var chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();  
}


const apexDashGIOpen = (data, divID) => {
    // data should be @gold_indicators from controller
    let traces = [{
        name: 'Open Percentage',
        data: [
            parseFloat(data.mainValues.open).toFixed(2), 
            parseFloat(data.metaValues.targets.open).toFixed(2), 
            parseFloat(data.metaValues.regionalBenchmarks.open).toFixed(2)
        ],
    }]
    let options = {
            series: traces,
            chart: {
                type: 'bar',
                height: 300,
                fontFamily: 'Maven Pro, sans-serif',
                // dropShadow: {
                //     enabled: true,
                //     color: '#000',
                //     blur: 5,
                //     top: 5,
                //     right: 10,
                //     opacity: 0.2
                // },
            },
            // colors: ['#546E7A', '#E91E63'],
            annotations: {
                xaxis: [{
                x: 500,
                borderColor: '#00E396',
                label: {
                    borderColor: '#00E396',
                    style: {
                    color: '#fff',
                    background: '#00E396',
                    },
                    text: 'X annotation',
                }
                }],
            },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'start',
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    // Access the category name from w.config.xaxis.categories
                    let category = w.config.xaxis.categories[dataPointIndex];
                    return category + ": " + value + "%";
                },
                position: 'end',
                style: {
                    fontSize: '18px',
                    colors: ['black'],
                    fontWeight: 400
                },
                dropShadow: {
                    enabled: true,
                    top: 0.5
                }
            },
            xaxis: {
                categories: ["Your Ranch", "Target", "Regional Benchmark"],
            },
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
                xaxis: {
                    lines: {
                        show: true
                    }
                },   
                yaxis: {
                    lines: {
                        show: true
                    }
                },  
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },  
            },
            yaxis: {
                reversed: false,
                fontSize: '24px',
                axisTicks: {
                    show: true
                },
                lines: {
                    show: true
                },
                labels: {
                    // maxWidth: 160,
                    show: false,
                    style: {
                        colors: ['red', 'gray', 'gray'],
                        fontFamily: 'Maven Pro, sans-serif',
                        fontSize: '14px',
                        maxWidth: 50,
                        // fontWeight: 900,
                    }
                }
            },
            theme: {
                palette: 'palette1'
            }
        };

    var chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();  
}

const apexDashGIDeath = (data, divID) => {
    // data should be @gold_indicators from controller
    let traces = [{
        name: 'Death Percentage',
        data: [
            parseFloat(data.mainValues.death).toFixed(2), 
            parseFloat(data.metaValues.targets.death).toFixed(2), 
            parseFloat(data.metaValues.regionalBenchmarks.death).toFixed(2)
        ],
    }]
    let options = {
            series: traces,
            chart: {
                type: 'bar',
                height: 300,
                fontFamily: 'Maven Pro, sans-serif',
                // dropShadow: {
                //     enabled: true,
                //     color: '#000',
                //     blur: 5,
                //     top: 5,
                //     right: 10,
                //     opacity: 0.2
                // },
            },
            // colors: ['#546E7A', '#E91E63'],
            annotations: {
                xaxis: [{
                x: 500,
                borderColor: '#00E396',
                label: {
                    borderColor: '#00E396',
                    style: {
                    color: '#fff',
                    background: '#00E396',
                    },
                    text: 'X annotation',
                }
                }],
            },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'start',
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    // Access the category name from w.config.xaxis.categories
                    let category = w.config.xaxis.categories[dataPointIndex];
                    return category + ": " + value + "%";
                },
                position: 'end',
                style: {
                    fontSize: '18px',
                    colors: ['black'],
                    fontWeight: 400
                },
                dropShadow: {
                    enabled: true,
                    top: 0.5
                }
            },
            xaxis: {
                categories: ["Your Ranch", "Target", "Regional Benchmark"],
            },
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
                xaxis: {
                    lines: {
                        show: true
                    }
                },   
                yaxis: {
                    lines: {
                        show: true
                    }
                },  
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },  
            },
            yaxis: {
                reversed: false,
                fontSize: '24px',
                axisTicks: {
                    show: true
                },
                lines: {
                    show: true
                },
                labels: {
                    // maxWidth: 160,
                    show: false,
                    style: {
                        colors: ['red', 'gray', 'gray'],
                        fontFamily: 'Maven Pro, sans-serif',
                        fontSize: '14px',
                        maxWidth: 50,
                        // fontWeight: 900,
                    }
                }
            },
            theme: {
                palette: 'palette1'
            }
        };

    var chart = new ApexCharts(document.querySelector(divID), options);
    chart.render(); 
}

const apexDashGILength = (data, divID) => {
    // data should be @gold_indicators from controller
    let traces = [{
        name: 'Length of Calving Period (days)',
        data: [
            parseFloat(data.mainValues.length).toFixed(2), 
            parseFloat(data.metaValues.targets.length).toFixed(2), 
            parseFloat(data.metaValues.regionalBenchmarks.length).toFixed(2)
        ],
    }]
    let options = {
            series: traces,
            chart: {
                type: 'bar',
                height: 300,
                fontFamily: 'Maven Pro, sans-serif',
                // dropShadow: {
                //     enabled: true,
                //     color: '#000',
                //     top: 5,
                //     right: 10,
                //     blur: 5,
                //     opacity: 0.2
                // },
            },
            // colors: ['#546E7A', '#E91E63'],
            annotations: {
                xaxis: [{
                x: 500,
                borderColor: '#00E396',
                label: {
                    borderColor: '#00E396',
                    style: {
                    color: '#fff',
                    background: '#00E396',
                    },
                    text: 'X annotation',
                }
                }],
            },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'start',
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    // Access the category name from w.config.xaxis.categories
                    let category = w.config.xaxis.categories[dataPointIndex];
                    return category + ": " + value + " days";
                },
                position: 'end',
                style: {
                    fontSize: '18px',
                    colors: ['black'],
                    fontWeight: 400
                },
                dropShadow: {
                    enabled: true,
                    top: 0.5
                }
            },
            xaxis: {
                categories: ["Your Ranch", "Target", "Regional Benchmark"],
            },
            grid: {
                borderColor: '#e7e7e7',
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
                xaxis: {
                    lines: {
                        show: true
                    }
                },   
                yaxis: {
                    lines: {
                        show: true
                    }
                },  
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },  
            },
            yaxis: {
                reversed: false,
                fontSize: '24px',
                axisTicks: {
                    show: true
                },
                lines: {
                    show: true
                },
                labels: {
                    // maxWidth: 160,
                    show: false,
                    style: {
                        colors: ['red', 'gray', 'gray'],
                        fontFamily: 'Maven Pro, sans-serif',
                        fontSize: '14px',
                        maxWidth: 50,
                        // fontWeight: 900,
                    }
                }
            },
            theme: {
                palette: 'palette1'
            }
        };

    var chart = new ApexCharts(document.querySelector(divID), options);
    chart.render(); 
}

const apexDashHerdAgeBoxPlot = (data, divID) => {
    console.log("from apexDashHerdAgeBoxPlot", data)
    let boxData = {
        "Calves": getMinQ1MedianQ3Max(data.calfAges),
        "Dams": getMinQ1MedianQ3Max(data.damAges),
        "Sires": getMinQ1MedianQ3Max(data.sireAges),
        "Steers": getMinQ1MedianQ3Max(data.steerAges),
    }
    console.log("boxData", boxData)
    let options = {
        series: [{
            data: Object.keys(boxData).map(key => {
                return {
                    x: key,
                    y: boxData[key]
                }
            })
        }],
        chart: {
            type: 'boxPlot',
            height: 375
        },
        colors: ['#008FFB', '#FEB019'],
        title: {
            text: 'Box Plot of Age Distribution by Animal Type',
            align: 'left'
        
        },
        tooltip: {
            shared: false,
            intersect: true
        },
        noData: {
            text: 'No Production Cycles Found...',
        },
        // yaxis: [
        //     {
        //         min: 0,
        //         max: Math.max(boxData["Calves"]) + 50
        //     },
        //     {
        //         min: 0,
        //         max: Math.max(boxData["Dams"]) + 50
        //     }
        // ]
    };

    let chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();
  
}

const apexWeaningAgeBoxPlot = (data, divID) => {
    console.log("from apexWeaningAgeBoxPlot", data)
    let boxData = Object.keys(data).sort().map(year => {
        return {
            year: year,
            plotData: getMinQ1MedianQ3Max(data[year]),
        }
    })
    console.log("boxData", boxData)
    let traces = boxData.length > 0 ? boxData : []
    let options = {
        series: [{
            data: boxData.map(d => {
                return {
                    x: d.year,
                    y: d.plotData
                }
            })
        }],
        chart: {
            type: 'boxPlot',
            height: 375
        },
        colors: ['#008FFB', '#FEB019'],
        title: {
            text: 'Box Plot of Weaning Ages by Production Cycle',
            align: 'left'
        
        },
        noData: {
            text: 'No Production Cycles Found...'
        },
        tooltip: {
            shared: false,
            intersect: true
        }
    };

    let chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();
  

}

const apexDashHerdAgeDistribution = (data, divID) => {
    let binSize = 10
    data = {
        // "Calves": data.calfAges.map(age => Math.floor(age/binSize)*binSize),
        "Dams": data.damAges.map(age => Math.floor(age/binSize)*binSize),
        "Sires": data.sireAges,
        "Steers": data.steerAges,
    }
    Object.keys(data).forEach(key => {
        data[key] = data[key].map(age => Math.floor(age))
    })
    let allAges = data.Dams.concat(data.Sires).concat(data.Steers)
    console.log("allAges", allAges)
    let xCategories = []
    let xKey;
    const maxAge = statsMax(allAges);
    const minAge = statsMin(allAges);
    for (let i = -1; i < (maxAge - minAge); i++) {
        xKey = 1 + i + minAge;
        xCategories.push(xKey);
    }
    var options = {
        series: Object.keys(data).map(animalType => {
            return {
                name: animalType,
                data: xCategories.map(age => countOccurrences(data[animalType], age))
            }
        }),
        chart: {
        height: 375,
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'stepline',
        lineCap: 'round'
      },
      xaxis: {
        // type: 'datetime',
        categories: xCategories
      },
      title: {
        text: 'Distribution of Age by Animal Type',
        align: 'left'
        },
      };

      var chart = new ApexCharts(document.querySelector(divID), options);
      chart.render();
}

const apexDashHerdCalvesPerDamBoxPlot = (data, divID) => {
    let years = Object.keys(data)
    let boxData = {}
    years.forEach(year => {
        Object.keys(data[year]).forEach(dam => {
            if (!boxData[year]) {
                boxData[year] = []
            }
            boxData[year].push(data[year][dam])
        })
        boxData[year] = getMinQ1MedianQ3Max(boxData[year])
    })
    let options = {
        series: [{
            data: Object.keys(boxData).map(key => {
                return {
                    x: key,
                    y: boxData[key]
                }
            })
        }],
        chart: {
            type: 'boxPlot',
            height: 375
        },
        colors: ['#008FFB', '#FEB019'],
        title: {
            text: 'Box Plot of Age by Animal Type',
            align: 'left'
        
        },
        tooltip: {
            shared: false,
            intersect: true
        }
    };

    let chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();
  
}

const apexDashHerdCalvesPerDamDistribution = (data, divID) => {

    let years = Object.keys(data)
    let xCategories = []
    var options = {
        series: years.map(year => {
            return {
                name: year,
                data: xCategories.map(age => countOccurrences(data[year], age))
            }
        }),
        // series: ["Calves", "Dams", "Sires", "Steers"].map(animalType => {
        //             return {
        //                 name: animalType,
        //                 data: xCategories.map(age => countOccurrences(data[animalType], age))
        //             }
        //     }),
        chart: {
            height: 375,
            type: 'area'
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'stepline',
            lineCap: 'round'
        },
        xaxis: {
            // type: 'datetime',
            categories: xCategories
        },
        title: {
            text: 'Distribution of Age by Animal Type',
            align: 'left'
        },
    };

    var chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();

}


const apexWeaningWeightBoxPlot = (data, divID) => {
    console.log("from apexWeaningWeightBoxPlot", data)
    let boxData = Object.keys(data).sort().map(year => {
        return {
            year: year,
            plotData: getMinQ1MedianQ3Max(data[year]),
        }
    })
    console.log("boxData", boxData)
    let traces = boxData.length > 0 ? boxData : []
    let options = {
        series: [{
            data: boxData.map(d => {
                return {
                    x: d.year,
                    y: d.plotData
                }
            })
        }],
        chart: {
            type: 'boxPlot',
            height: 375
        },
        colors: ['#008FFB', '#FEB019'],
        title: {
            text: 'Box Plot of Weaning Weights by Production Cycle',
            align: 'left'
        
        },
        noData: {
            text: 'No Production Cycles Found...'
        },
        tooltip: {
            shared: false,
            intersect: true
        }
    };

    let chart = new ApexCharts(document.querySelector(divID), options);
    chart.render();
  

}
































